import React from 'react'
import { StyleSheet, View, ViewStyle } from 'react-native'
// import styles from './index.scss'

interface Props {
    width?: string|number;
    height?: string|number;
    style?: ViewStyle|Array<ViewStyle>;
}

const Hstack: React.FC<Props> = (props) => {

    const {
        width,
        height,
        style
    } = props;

    const HstackStyle: ViewStyle = {
        width: width,
        height: height
    };

    return (
        <View {...props} style={[styles.hstack, style, HstackStyle]}>
            {props.children}
        </View>
    );

};

const styles = StyleSheet.create({
    hstack: {
        display: 'flex',
        flexDirection: 'row'
    }
});

export {
    Hstack
}